// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cart-detail-container {
  position: absolute;
  right: 0;
  top: 0;
  z-index: 9999;
  width: 36.77vw;
  height: 100%;
  max-height: 100%;
  overflow: auto;
  bottom: 0;
  box-shadow: -0.35vw -0.35vw 17.35vw 0 rgba(255, 255, 255, 0.0196078431);
  background: radial-gradient(100% 100% at 0% 0%, rgba(53, 38, 38, 0.4) 0%, rgba(38, 26, 26, 0.1) 100%);
  backdrop-filter: blur(2.92vw);
  transition: all 0.75s ease;
  /* Customize the thumb */
  /* Customize the track */
}
.cart-detail-container .close {
  display: flex;
  justify-content: end;
  position: relative;
  right: 2.22vw;
  right: unset;
  margin-right: 10px;
}
.cart-detail-container .close .close-icon {
  background: radial-gradient(100% 100% at 0% 0%, rgba(255, 255, 255, 0.4) 0%, rgba(255, 255, 255, 0.81) 100%);
  margin-right: 2.22vw;
  width: 2.775vw;
  height: 2.775vw;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-right: unset;
}
.cart-detail-container .cart-detail {
  margin: 0 2.22vw;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 55px);
  justify-content: space-between;
}
.cart-detail-container .cart-detail .cart-detail-title {
  margin-bottom: 2.22vw;
  display: flex;
  justify-content: space-between;
  margin-bottom: 1.11vw;
}
.cart-detail-container .cart-detail .cart-detail-title h3 {
  font-size: 1.53vw;
  color: #fff;
}
.cart-detail-container .cart-detail .cart-detail-wrapper {
  overflow: auto;
  flex-grow: 1;
}
.cart-detail-container .cart-detail .cart-detail-wrapper .prod-wrapper {
  display: flex;
  justify-content: space-between;
  border: 2px solid;
  background: radial-gradient(100% 100% at 0% 0%, rgba(255, 255, 255, 0.4) 0%, rgba(255, 255, 255, 0) 100%);
  box-shadow: -5px -5px 250px 0px rgba(255, 255, 255, 0.0196078431) inset;
  border-image-source: linear-gradient(169.15deg, rgba(255, 255, 255, 0.4) 0%, rgba(238, 237, 237, 0.2) 96.79%);
  padding: 1.3875vw 1.25vw;
}
.cart-detail-container .cart-detail .cart-detail-wrapper .prod-wrapper .prod-det-wrapper {
  display: flex;
}
.cart-detail-container .cart-detail .cart-detail-wrapper .prod-wrapper .prod-det-wrapper .prod-img {
  width: 5.55vw;
  height: 5.55vw;
}
.cart-detail-container .cart-detail .cart-detail-wrapper .prod-wrapper .prod-det-wrapper .prod-img img {
  width: 100%;
  height: 100%;
}
.cart-detail-container .cart-detail .cart-detail-wrapper .prod-wrapper .prod-det-wrapper .prod-quantity-wrapper {
  position: relative;
  left: 1.11vw;
}
.cart-detail-container .cart-detail .cart-detail-wrapper .prod-wrapper .quantity {
  display: flex;
  align-items: center;
}
.cart-detail-container .cart-detail .cart-detail-wrapper .prod-wrapper .quantity .prod-count {
  background-color: transparent;
  border: 1px solid #ffffff;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 1.5vw;
}
.cart-detail-container .cart-detail .cart-detail-wrapper .prod-wrapper .quantity .prod-count .count {
  padding: 0.555vw 2.5vw;
}
.cart-detail-container .cart-detail .cart-detail-wrapper .prod-wrapper .quantity .prod-count span {
  display: flex;
}
.cart-detail-container .cart-detail .cart-detail-wrapper .prod-wrapper .quantity .prod-count .subtract {
  position: relative;
  left: 0.55vw;
  cursor: pointer;
}
.cart-detail-container .cart-detail .cart-detail-wrapper .prod-wrapper .quantity .prod-count .add {
  position: relative;
  right: 0.55vw;
  cursor: pointer;
}
.cart-detail-container .cart-detail .cart-detail-wrapper .prod-wrapper .quantity .delete {
  margin-left: 0.2775vw;
  margin-top: 1.5vw;
}
.cart-detail-container .cart-detail .cart-detail-wrapper .prod-wrapper:nth-child(1) {
  margin: 0;
}
.cart-detail-container .cart-detail .cart-detail-wrapper .prod-wrapper:nth-child(2),
.cart-detail-container .cart-detail .cart-detail-wrapper .prod-wrapper:nth-child(3) {
  margin: 1.11vw 0;
}
.cart-detail-container .subtotal {
  display: flex;
  justify-content: space-between;
  margin: 0.555vw 0;
}
.cart-detail-container .title {
  font-size: 1.05vw;
  font-weight: 500;
  color: #fff;
}
.cart-detail-container .prod-title,
.cart-detail-container .amount,
.cart-detail-container .subtotal p {
  font-weight: 500;
  font-size: 1.25vw;
  line-height: 1.49vw;
  color: #ffffff;
  letter-spacing: 2%;
}
.cart-detail-container .checkout-btn {
  margin: 1.11vw 0;
}
.cart-detail-container .checkout-btn button {
  width: 100%;
  background-color: #fff;
  font-size: 1.25vw;
  font-weight: 400;
  line-height: 1.25vw;
  text-align: center;
  color: #3f3636;
  border: none;
  padding: 1vw;
  cursor: pointer;
}
.cart-detail-container .checkout-btn p {
  font-size: 1.11vw;
  font-weight: 400;
  line-height: 1.33vw;
  color: #ffffff;
  letter-spacing: 2%;
  margin: 1.11vw 0;
}
.cart-detail-container ::-webkit-scrollbar {
  width: 0.42vw; /* Width of the scrollbar */
}
.cart-detail-container ::-webkit-scrollbar-thumb {
  background: radial-gradient(100% 100% at 0% 0%, rgba(255, 255, 255, 0.57) 70%, rgba(255, 255, 255, 0.81) 100%);
  box-shadow: -5px -5px 250px 0px rgba(255, 255, 255, 0.0196078431) inset;
  border-radius: 1.46vw; /* Rounded corners */
}
.cart-detail-container ::-webkit-scrollbar-track {
  background: radial-gradient(100% 100% at 0% 0%, rgba(255, 255, 255, 0.57) 70%, rgba(255, 255, 255, 0.81) 100%);
  box-shadow: -5px -5px 250px 0px rgba(255, 255, 255, 0.0196078431) inset;
}
@media only screen and (max-width: 768px) {
  .cart-detail-container {
    min-width: 400px;
  }
  .cart-detail-container h3 {
    font-size: 20px !important;
    line-height: unset !important;
  }
  .cart-detail-container p,
  .cart-detail-container button {
    font-size: 16px !important;
    line-height: unset !important;
  }
  .cart-detail-container .policy {
    font-size: 14px !important;
    line-height: unset !important;
  }
  .cart-detail-container .close .close-icon {
    width: 30px !important;
    height: 30px !important;
    margin-top: 10px !important;
  }
  .cart-detail-container .cart-detail .cart-detail-wrapper .prod-wrapper .prod-det-wrapper .prod-img {
    width: 60px !important;
    height: 60px !important;
    object-fit: cover !important;
  }
  .cart-detail-container .cart-detail .cart-detail-wrapper .prod-wrapper .prod-det-wrapper .prod-quantity-wrapper {
    left: 15px;
  }
  .cart-detail-container .cart-detail .cart-detail-wrapper .prod-wrapper .quantity {
    justify-content: space-between;
  }
  .cart-detail-container .cart-detail .cart-detail-wrapper .prod-wrapper .quantity .prod-count {
    padding: 2.5px 10px;
    margin-top: 10px;
  }
  .cart-detail-container .cart-detail .cart-detail-wrapper {
    margin: 15px 0;
  }
  .cart-detail-container .checkout-btn button {
    margin: 10px 0;
  }
}
@media only screen and (max-width: 426px) {
  .cart-detail-container {
    min-width: 1px !important;
    width: 100% !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/style/components/three/Cart.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,QAAA;EACA,MAAA;EACA,aAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,uEAAA;EACA,qGAAA;EAMA,6BAAA;EACA,0BAAA;EAgMA,wBAAA;EAaA,wBAAA;AA/MF;AAIE;EACE,aAAA;EACA,oBAAA;EACA,kBAAA;EACA,aAAA;EAGA,YAAA;EACA,kBAAA;AAJJ;AAMI;EACE,4GAAA;EAMA,oBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EAGA,mBAAA;AAXN;AAcE;EACE,gBAAA;EAGA,aAAA;EACA,sBAAA;EACA,0BAAA;EACA,8BAAA;AAdJ;AAgBI;EACE,qBAAA;EACA,aAAA;EACA,8BAAA;EACA,qBAAA;AAdN;AAeM;EACE,iBAAA;EACA,WAAA;AAbR;AAgBI;EACE,cAAA;EACA,YAAA;AAdN;AAgBM;EACE,aAAA;EACA,8BAAA;EACA,iBAAA;EACA,yGAAA;EAMA,uEAAA;EACA,6GAAA;EAKA,wBAAA;AAvBR;AAyBQ;EACE,aAAA;AAvBV;AAyBU;EACE,aAAA;EACA,cAAA;AAvBZ;AAyBY;EACE,WAAA;EACA,YAAA;AAvBd;AA2BU;EACE,kBAAA;EACA,YAAA;AAzBZ;AA6BQ;EACE,aAAA;EACA,mBAAA;AA3BV;AA6BU;EACE,6BAAA;EACA,yBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;AA3BZ;AA6BY;EACE,sBAAA;AA3Bd;AA8BY;EACE,aAAA;AA5Bd;AA+BY;EACE,kBAAA;EACA,YAAA;EACA,eAAA;AA7Bd;AAgCY;EACE,kBAAA;EACA,aAAA;EACA,eAAA;AA9Bd;AAkCU;EACE,qBAAA;EACA,iBAAA;AAhCZ;AAoCM;EACE,SAAA;AAlCR;AAoCM;;EAEE,gBAAA;AAlCR;AAyCE;EACE,aAAA;EACA,8BAAA;EACA,iBAAA;AAvCJ;AAyCE;EACE,iBAAA;EACA,gBAAA;EACA,WAAA;AAvCJ;AA0CE;;;EAGE,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;AAxCJ;AA0CE;EACE,gBAAA;AAxCJ;AA0CI;EACE,WAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;AAxCN;AA0CI;EACE,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AAxCN;AA2CE;EACE,aAAA,EAAA,2BAAA;AAzCJ;AA6CE;EACE,8GAAA;EAMA,uEAAA;EAEA,qBAAA,EAAA,oBAAA;AAjDJ;AAqDE;EACE,8GAAA;EAMA,uEAAA;AAxDJ;AA2DE;EA1OF;IA2OI,gBAAA;EAxDF;EAyDE;IACE,0BAAA;IACA,6BAAA;EAvDJ;EAyDE;;IAEE,0BAAA;IACA,6BAAA;EAvDJ;EAyDE;IACE,0BAAA;IACA,6BAAA;EAvDJ;EAyDE;IACE,sBAAA;IACA,uBAAA;IACA,2BAAA;EAvDJ;EAyDE;IAKE,sBAAA;IACA,uBAAA;IACA,4BAAA;EA3DJ;EA6DE;IAKE,UAAA;EA/DJ;EAiEE;IACE,8BAAA;EA/DJ;EAiEE;IACE,mBAAA;IACA,gBAAA;EA/DJ;EAiEE;IACE,cAAA;EA/DJ;EAiEE;IACE,cAAA;EA/DJ;AACF;AAiEE;EA5RF;IA6RI,yBAAA;IACA,sBAAA;EA9DF;AACF","sourcesContent":[".cart-detail-container {\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 9999;\n  width: 36.77vw;\n  height: 100%;\n  max-height: 100%;\n  overflow: auto;\n  bottom: 0;\n  box-shadow: -0.35vw -0.35vw 17.35vw 0 #ffffff05;\n  background: radial-gradient(\n      100% 100% at 0% 0%,\n      rgba(53, 38, 38, 0.4) 0%,\n      rgba(38, 26, 26, 0.1) 100%\n    )\n    /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */;\n  backdrop-filter: blur(2.92vw);\n  transition: all 0.75s ease;\n\n  .close {\n    display: flex;\n    justify-content: end;\n    position: relative;\n    right: 2.22vw;\n\n    // checck\n    right: unset;\n    margin-right: 10px;\n\n    .close-icon {\n      background: radial-gradient(\n          100% 100% at 0% 0%,\n          rgba(255, 255, 255, 0.4) 0%,\n          rgba(255, 255, 255, 0.81) 100%\n        )\n        /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */;\n      margin-right: 2.22vw;\n      width: 2.775vw;\n      height: 2.775vw;\n      border-radius: 50%;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      cursor: pointer;\n\n      // check\n      margin-right: unset;\n    }\n  }\n  .cart-detail {\n    margin: 0 2.22vw;\n\n    //check\n    display: flex;\n    flex-direction: column;\n    height: calc(100vh - 55px);\n    justify-content: space-between;\n\n    .cart-detail-title {\n      margin-bottom: 2.22vw;\n      display: flex;\n      justify-content: space-between;\n      margin-bottom: 1.11vw;\n      h3 {\n        font-size: 1.53vw;\n        color: #fff;\n      }\n    }\n    .cart-detail-wrapper {\n      overflow: auto;\n      flex-grow: 1;\n\n      .prod-wrapper {\n        display: flex;\n        justify-content: space-between;\n        border: 2px solid;\n        background: radial-gradient(\n            100% 100% at 0% 0%,\n            rgba(255, 255, 255, 0.4) 0%,\n            rgba(255, 255, 255, 0) 100%\n          )\n          /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */;\n        box-shadow: -5px -5px 250px 0px #ffffff05 inset;\n        border-image-source: linear-gradient(\n          169.15deg,\n          rgba(255, 255, 255, 0.4) 0%,\n          rgba(238, 237, 237, 0.2) 96.79%\n        );\n        padding: 1.3875vw 1.25vw;\n\n        .prod-det-wrapper {\n          display: flex;\n\n          .prod-img {\n            width: 5.55vw;\n            height: 5.55vw;\n\n            img {\n              width: 100%;\n              height: 100%;\n            }\n          }\n\n          .prod-quantity-wrapper {\n            position: relative;\n            left: 1.11vw;\n          }\n        }\n\n        .quantity {\n          display: flex;\n          align-items: center;\n\n          .prod-count {\n            background-color: transparent;\n            border: 1px solid #ffffff;\n            color: #fff;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            margin-top: 1.5vw;\n\n            .count {\n              padding: 0.555vw 2.5vw;\n            }\n\n            span {\n              display: flex;\n            }\n\n            .subtract {\n              position: relative;\n              left: 0.55vw;\n              cursor: pointer;\n            }\n\n            .add {\n              position: relative;\n              right: 0.55vw;\n              cursor: pointer;\n            }\n          }\n\n          .delete {\n            margin-left: 0.2775vw;\n            margin-top: 1.5vw;\n          }\n        }\n      }\n      .prod-wrapper:nth-child(1) {\n        margin: 0;\n      }\n      .prod-wrapper:nth-child(2),\n      .prod-wrapper:nth-child(3) {\n        margin: 1.11vw 0;\n      }\n    }\n  }\n  // hr{\n  //   margin: 0 2.22vw;\n  // }\n  .subtotal {\n    display: flex;\n    justify-content: space-between;\n    margin: 0.555vw 0;\n  }\n  .title {\n    font-size: 1.05vw;\n    font-weight: 500;\n    color: #fff;\n  }\n\n  .prod-title,\n  .amount,\n  .subtotal p {\n    font-weight: 500;\n    font-size: 1.25vw;\n    line-height: 1.49vw;\n    color: #ffffff;\n    letter-spacing: 2%;\n  }\n  .checkout-btn {\n    margin: 1.11vw 0;\n\n    button {\n      width: 100%;\n      background-color: #fff;\n      font-size: 1.25vw;\n      font-weight: 400;\n      line-height: 1.25vw;\n      text-align: center;\n      color: #3f3636;\n      border: none;\n      padding: 1vw;\n      cursor: pointer;\n    }\n    p {\n      font-size: 1.11vw;\n      font-weight: 400;\n      line-height: 1.33vw;\n      color: #ffffff;\n      letter-spacing: 2%;\n      margin: 1.11vw 0;\n    }\n  }\n  ::-webkit-scrollbar {\n    width: 0.42vw; /* Width of the scrollbar */\n  }\n\n  /* Customize the thumb */\n  ::-webkit-scrollbar-thumb {\n    background: radial-gradient(\n        100% 100% at 0% 0%,\n        rgba(255, 255, 255, 0.57) 70%,\n        rgba(255, 255, 255, 0.81) 100%\n      )\n      /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */;\n    box-shadow: -5px -5px 250px 0px #ffffff05 inset;\n\n    border-radius: 1.46vw; /* Rounded corners */\n  }\n\n  /* Customize the track */\n  ::-webkit-scrollbar-track {\n    background: radial-gradient(\n        100% 100% at 0% 0%,\n        rgba(255, 255, 255, 0.57) 70%,\n        rgba(255, 255, 255, 0.81) 100%\n      )\n      /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */;\n    box-shadow: -5px -5px 250px 0px #ffffff05 inset;\n  }\n\n  @media only screen and (max-width: 768px) {\n    min-width: 400px;\n    h3 {\n      font-size: 20px !important;\n      line-height: unset !important;\n    }\n    p,\n    button {\n      font-size: 16px !important;\n      line-height: unset !important;\n    }\n    .policy {\n      font-size: 14px !important;\n      line-height: unset !important;\n    }\n    .close .close-icon {\n      width: 30px !important;\n      height: 30px !important;\n      margin-top: 10px !important;\n    }\n    .cart-detail\n      .cart-detail-wrapper\n      .prod-wrapper\n      .prod-det-wrapper\n      .prod-img {\n      width: 60px !important;\n      height: 60px !important;\n      object-fit: cover !important;\n    }\n    .cart-detail\n      .cart-detail-wrapper\n      .prod-wrapper\n      .prod-det-wrapper\n      .prod-quantity-wrapper {\n      left: 15px;\n    }\n    .cart-detail .cart-detail-wrapper .prod-wrapper .quantity {\n      justify-content: space-between;\n    }\n    .cart-detail .cart-detail-wrapper .prod-wrapper .quantity .prod-count {\n      padding: 2.5px 10px;\n      margin-top: 10px;\n    }\n    .cart-detail .cart-detail-wrapper {\n      margin: 15px 0;\n    }\n    .checkout-btn button {\n      margin: 10px 0;\n    }\n  }\n  @media only screen and (max-width: 426px) {\n    min-width: 1px !important;\n    width: 100% !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
